<template>
  <div class="base">
    <Navbar></Navbar>
    <router-view/>
  </div>
</template>

<style lang="scss">
body {
  font-size: 16px;
  --white: #FFFFFF;
  --grey: #8CA3A8;
  --orange: #E25925;
  --black: #000000;
  background: var(--black);
  background-size: 100%;
  -webkit-tap-highlight-color: transparent;
  width: 100vw;
  margin: 0;
  text-align: center;
  overflow-x: hidden;
}
#app, .base {
  font-family: "Roboto", Roboto, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-flow: column;
  height: 100%;
  color: var(--white);
}
@font-face {
  font-family: "Brandon";
  src: url(assets/fonts/Brandon-Regular.otf) format("opentype");
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: "Brandon-Bold";
  src: url(assets/fonts/Brandon-Bold.otf) format("opentype");
  font-style: normal;
  font-display: block;
}
h1 {
  font-family: "Brandon-Bold", Roboto, sans-serif;
  font-size: calc(2.5em + 0.2vw);
}
h2 {
  font-family: "Brandon-Bold", Roboto, sans-serif;
  font-size: calc(1.2em + 0.2vw);
}
p {
  font-family: "Brandon", Roboto, sans-serif;
  font-size: 1em;
}
b {
  font-family: "Brandon-Bold", Roboto, sans-serif;
  font-size: 1em;
  font-weight: 500;
}
a {
  color: var(--grey);
  outline: solid 2px var(--grey);
  background-color: #00000044;
  width: 16em;
  padding: 0 2em;
  border-radius: 0.5em;
  transition: 0.1s;
  text-decoration: none;
}
a:hover {
  color: var(--white);
  outline: solid 2px var(--white);
  background-color: #8CA3A8AA;
}
.orange {
  color: var(--orange);
  outline: solid 2px var(--orange);
  img {
    width: 1em;
    height: 1em;
    margin-right: 0.4em;
    transform: translateY(2px);
    transition: 0.1s;
  }
}
.orange:hover {
  color: var(--white);
  outline: solid 2px var(--white);
  background-color: #E25925AA;
  img {
    filter: brightness(0) invert(1);
  }
}
</style>